// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

export const Overview = () => {
  return (
    <section
      className="overview-modern-section position-relative py-5"
      id="overview"
      style={{
        background: 'linear-gradient(120deg, #f8fafc 60%, #e3e8ee 100%)',
        overflow: 'hidden',
      }}
    >
      {/* Decorative gradient blobs */}
      <div style={{
        position: 'absolute',
        top: '-100px',
        left: '-120px',
        width: '320px',
        height: '320px',
        background: 'radial-gradient(circle, #e81f29 0%, #fff0 70%)',
        zIndex: 0,
        opacity: 0.18,
        borderRadius: '50%',
        filter: 'blur(2px)'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-80px',
        right: '-100px',
        width: '260px',
        height: '260px',
        background: 'radial-gradient(circle, #0d6efd 0%, #fff0 70%)',
        zIndex: 0,
        opacity: 0.15,
        borderRadius: '50%',
        filter: 'blur(2px)'
      }} />
      <div style={{
        position: 'absolute',
        top: '40%',
        left: '50%',
        width: '180px',
        height: '180px',
        background: 'radial-gradient(circle, #fd7e14 0%, #fff0 70%)',
        zIndex: 0,
        opacity: 0.10,
        borderRadius: '50%',
        transform: 'translate(-50%, -50%)',
        filter: 'blur(2px)'
      }} />
      {/* Subtle pattern overlay */}
      <div style={{
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        pointerEvents: 'none',
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'40\' height=\'40\' viewBox=\'0 0 40 40\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Ccircle cx=\'1\' cy=\'1\' r=\'1\' fill=\'%23e3e8ee\'/%3E%3C/svg%3E")',
        opacity: 0.18,
      }} />
      <div className="container position-relative" style={{zIndex: 2}}>
        <h2 className="text-center fw-bold display-4 mb-2" style={{letterSpacing: 1}}>Why CityDrive?</h2>
        <p className="text-center text-secondary fs-5 mb-5" style={{maxWidth: 600, margin: '0 auto'}}>
          Every Mile is a Memory. Rent a Car, Embark on Epic Tours, and Experience Zambia with Confidence.
        </p>
        <div className="row justify-content-center align-items-end g-4 mb-2">
          {/* Center 3 main features */}
          {[
            {
              icon: 'fa-solid fa-headset',
              color: '#e81f29',
              title: '24/7 Support',
              text: 'Always here for you, wherever you go.',
            },
            {
              icon: 'fa-solid fa-gauge-high',
              color: '#0d6efd',
              title: 'Unlimited Mileage',
              text: 'No extra charges for your adventures.',
            },
            {
              icon: 'fa-solid fa-car-burst',
              color: '#198754',
              title: 'Full Insurance',
              text: 'Drive with peace of mind, always covered.',
            },
          ].map((item, idx) => (
            <div key={item.title} className="col-12 col-md-4 d-flex align-items-stretch mb-4 mb-md-0">
              <div
                className="overview-feature-card w-100 text-center p-4 shadow-sm border-0 bg-white h-100 rounded-4 transition-hover"
                style={{
                  transition: 'transform 0.2s',
                  cursor: 'pointer',
                }}
                onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-8px) scale(1.04)')}
                onMouseOut={e => (e.currentTarget.style.transform = 'none')}
              >
                <div className="mx-auto mb-3 d-flex align-items-center justify-content-center" style={{width: 70, height: 70, borderRadius: '50%', background: item.color + '22', boxShadow: `0 2px 12px ${item.color}22`}}>
                  <i className={`${item.icon} fa-2x`} style={{color: item.color}}></i>
                </div>
                <h5 className="fw-bold mb-2" style={{color: item.color}}>{item.title}</h5>
                <p className="text-secondary mb-0 fs-6">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="row justify-content-center g-4 mt-1">
          {/* 2 smaller features */}
          {[
            {
              icon: 'fa-solid fa-coins',
              color: '#fd7e14',
              title: 'Best Prices',
              text: 'Great cars at unbeatable rates.',
            },
            {
              icon: 'fa-regular fa-circle-check',
              color: '#6f42c1',
              title: 'Reliability',
              text: 'Well-maintained vehicles, always ready.',
            },
          ].map((item, idx) => (
            <div key={item.title} className="col-12 col-md-5 d-flex align-items-stretch">
              <div
                className="overview-feature-card w-100 text-center p-4 shadow-sm border-0 bg-white h-100 rounded-4 transition-hover"
                style={{
                  transition: 'transform 0.2s',
                  cursor: 'pointer',
                }}
                onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-6px) scale(1.03)')}
                onMouseOut={e => (e.currentTarget.style.transform = 'none')}
              >
                <div className="mx-auto mb-3 d-flex align-items-center justify-content-center" style={{width: 60, height: 60, borderRadius: '50%', background: item.color + '22', boxShadow: `0 2px 12px ${item.color}22`}}>
                  <i className={`${item.icon} fa-lg`} style={{color: item.color}}></i>
                </div>
                <h6 className="fw-bold mb-2" style={{color: item.color}}>{item.title}</h6>
                <p className="text-secondary mb-0 fs-6">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
